import { z } from 'zod';

/**
 * "Start a new conversation from here" (`POST /api/conversations/:id/copy`): a new conversation
 * with every message strictly before `beforeMessageId`; the original stays as it is.
 */
export const copyConversationRequestSchema = z
  .object({ beforeMessageId: z.string().min(1).max(256) })
  .strict();
export type CopyConversationRequest = z.infer<typeof copyConversationRequestSchema>;

/** The new conversation. */
export const copyConversationResponseSchema = z.object({
  conversationId: z.uuid(),
  title: z.string(),
});
export type CopyConversationResponse = z.infer<typeof copyConversationResponseSchema>;
